"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * CreateWebshop — Section 6: FAQ
 * Drop-in für: src/pages/CreateWebshop/sections/ClaimsFaq.tsx
 *
 * 6 häufige Fragen rund um Webshop-Setup, Zahlungen, MWST und Skalierung.
 */

const faqs = [{
  q: "Welche Zahlungsmethoden sind enthalten?",
  a: "Twint (Schweiz), Stripe für Kreditkarten weltweit, plus Apple Pay und Google Pay. Alles vorkonfiguriert und PCI-compliant. Sie brauchen nur Ihre Stripe- und Twint-Zugangsdaten."
}, {
  q: "Wie viele Produkte kann ich anbieten?",
  a: "Im Pro Webshop-Paket sind bis 50 Produkte enthalten. Wir pflegen alle Produkte mit Bildern und Beschreibungen für Sie ein. Mehr Produkte? Auf Anfrage individuell skalierbar."
}, {
  q: "Ist die Schweizer MWST schon konfiguriert?",
  a: "Ja. Sämtliche Schweizer MWST-Sätze sind vorkonfiguriert (Standard, reduziert, Sondersatz). Automatische PDF-Rechnungen werden nach jeder Bestellung an den Kunden gesendet."
}, {
  q: "Kann ich Versandkosten anpassen?",
  a: "Vollständig. Pauschalen, Gewicht-basierte Tarife, Versand-Pauschalen, Gratis-Versand ab Bestellwert, Versandregionen — alles flexibel einstellbar."
}, {
  q: "Was ist, wenn ich später wachsen will?",
  a: "WooCommerce auf WordPress ist endlos skalierbar. Bei mehr als 50 Produkten oder besonderen Anforderungen erstellen wir Ihnen ein individuelles Paket — Ihre Daten bleiben auf Ihrer Site."
}, {
  q: "Kann ich den Shop selbst nachher bearbeiten?",
  a: "Ja. Sie haben vollen Zugriff auf das WordPress-Backend. Produkte hinzufügen, Bilder ändern, Preise anpassen — alles selbst, jederzeit. Kein Lock-in."
}];
export default function ClaimsFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-3xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Häufige Fragen
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Was Sie noch wissen wollen.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, i) => <details key={i} className="group bg-background border border-border rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer px-6 py-5 font-medium text-foreground hover:bg-secondary/50 transition-colors">
                <span className="pr-4">{item.q}</span>
                <ChevronDown className="w-5 h-5 text-muted-foreground group-open:rotate-180 transition-transform shrink-0" />
              </summary>
              <div className="px-6 pb-5 text-muted-foreground leading-relaxed">
                {item.a}
              </div>
            </details>)}
        </div>
      </div>
    </section>;
}